<div class="loading-custom">
    {{ 'agGrid.agGridLoadingMsg' | translate }}
</div>